export default __webpack_public_path__ + "static/media/enotas.b8867630.svg";